/**
 * Definicje typów dokumentów dla połączonej listy „Dokumenty księgowe".
 * Wartość koduje grupę i podzakres: `{grupa}:{zakres}` (np. "inv:1", "bank:credit").
 * Wydzielone z komponentu, by nie łamać react-refresh (plik komponentu eksportuje
 * wyłącznie komponent).
 */

export type DocGroup = "inv" | "bank" | "jrn";

export interface DocTypeOption {
  value: string;
  label: string;
}

export const DOC_TYPE_GROUPS: { group: DocGroup; header: string; options: DocTypeOption[] }[] = [
  {
    group: "inv",
    header: "Faktury i rachunki",
    options: [
      { value: "inv:all", label: "Wszystkie" },
      { value: "inv:0", label: "Sprzedaż" },
      { value: "inv:1", label: "Zakup" },
      { value: "inv:2", label: "Inne podmioty" },
      { value: "inv:3", label: "Uprawniony podmiot" },
    ],
  },
  {
    group: "bank",
    header: "Transakcje bankowe",
    options: [
      { value: "bank:all", label: "Wszystkie" },
      { value: "bank:credit", label: "Wpływy" },
      { value: "bank:debit", label: "Wydatki" },
    ],
  },
  {
    group: "jrn",
    header: "Polecenia księgowania",
    options: [
      { value: "jrn:all", label: "Wszystkie" },
    ],
  },
];

export const DEFAULT_DOC_TYPE = "inv:all";

export const docGroupOf = (v: string): DocGroup => (v.split(":")[0] as DocGroup) || "inv";

export const docScopeOf = (v: string): string => v.split(":")[1] ?? "";

export const docLabelOf = (v: string): string => {
  for (const g of DOC_TYPE_GROUPS) {
    const o = g.options.find((o) => o.value === v);
    if (o) return o.label;
  }
  return "";
};

export const docHeaderOf = (v: string): string =>
  DOC_TYPE_GROUPS.find((g) => g.group === docGroupOf(v))?.header ?? "";

/** Etykieta do drugiego wiersza tytułu (podtytuł): grupa + zakres. */
export const docSubtitleLabel = (v: string): string => {
  const label = docLabelOf(v);
  return docGroupOf(v) === "inv" ? label : `${docHeaderOf(v)}: ${label}`;
};
